import React from 'react';

import Table from 'components/Table';
import Avatar from 'components/Avatar';
import Paginator from 'components/Paginator';

import {getBooleanIcon} from './utils';

import './styles.css';

const UserCell = ({
  user: {fullName, avatarCropped, internalAvatarCropped, email, initials}
}) => (
  <div className="userCell">
    <Avatar url={internalAvatarCropped || avatarCropped} initials={initials} />
    <div className="info">
      <div className="name">{fullName}</div>
      <div className="email">{email}</div>
    </div>
  </div>
);

const UsersTable = ({users, pagination, onPageChange, openUserDetailModal}) => (
  <div className="UsersTable">
    <div className="tableContainer">
      <div className="tableHeader">
        <Table>
          <Table.Header>
            <Table.HeaderItem className="nameColumn" heading="name" />
            <Table.HeaderItem
              className="identifierColumn"
              heading="identifier"
            />
            <Table.HeaderItem className="adminColumn" heading="admin" />
            <Table.HeaderItem className="memberColumn" heading="member" />
          </Table.Header>
        </Table>
      </div>
      <div className="tableBody">
        <Table>
          <Table.Body>
            {users.map(user => {
              return (
                <Table.Row
                  className="colab-clickable"
                  key={user.id}
                  onClick={() => openUserDetailModal(user.id)}>
                  <Table.Cell className="nameColumn">
                    <UserCell user={user} />
                  </Table.Cell>
                  <Table.Cell className="identifierColumn">
                    {!user.isMember && 'N/A'}
                    {user.isMember && user.memberId}
                  </Table.Cell>
                  <Table.Cell className="adminColumn">
                    {getBooleanIcon(
                      user.isAdmin,
                      'User is admin',
                      'User is not admin'
                    )}
                  </Table.Cell>
                  <Table.Cell className="memberColumn">
                    {getBooleanIcon(
                      user.isMember,
                      'User is member',
                      'User is not member'
                    )}
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    </div>
    <Paginator pagination={pagination} onPageChange={onPageChange} />
  </div>
);

export default UsersTable;
